import React, { FunctionComponent } from 'react';
import classnames from 'classnames';

import cross from '@/shared/assets/cross.svg';
import { useI18n } from '@/shared/hooks/useI18n';

import styles from './CloseButton.module.css';

type CloseButtonSize = 32 | 40 | 52;

type ElementColorScheme = 'dark' | 'light';

interface Props {
    onHandleClick: () => void;
    colorScheme?: ElementColorScheme;
    size?: CloseButtonSize;
}

export const CloseButton: FunctionComponent<Props> = ({
    onHandleClick,
    colorScheme = 'light',
    size = 32,
}) => {
    const i18n = useI18n();
    return (
        <button
            className={classnames(
                styles.root,
                {
                    [styles.rootLight]: colorScheme === 'light',
                    [styles.rootDark]: colorScheme === 'dark',
                },
                styles[`size-${size}`]
            )}
            onClick={onHandleClick}
            aria-label={i18n('close_button__aria_label')}
            type="button"
        >
            <img src={cross} alt="close" className={styles.icon} />
        </button>
    );
};
